import type { ReactNode } from "react";
import AuthSplitLayout from "./auth-split-layout";
import { Heading } from "../../../components/common/typography";
import { SegmentedControl } from "../../../components/common/segmented-control";

type AuthTab<V extends string> = {
  value: V;
  label: string;
};

type AuthShellProps<V extends string> = {
  title: string;
  tabs?: {
    ariaLabel: string;
    options: readonly AuthTab<V>[];
    value: V;
    onChange: (next: V) => void;
  };
  children: ReactNode;
};

export function AuthShell<V extends string>({
  title,
  tabs,
  children,
}: AuthShellProps<V>) {
  return (
    <AuthSplitLayout>
      <Heading variant="h2" tone="dark">
        {title}
      </Heading>
      {tabs ? (
        <SegmentedControl
          aria-label={tabs.ariaLabel}
          options={tabs.options}
          value={tabs.value}
          onChange={tabs.onChange}
        />
      ) : null}
      {children}
    </AuthSplitLayout>
  );
}

export default AuthShell;
